module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAYElEQVQ4y2NgGBygKu4/Mj4nqIYV/7kohoKHgAHXjJXBmGwDnhbIgTHJBtwNUPz/64Q4XOHPY+JgMZJccNNOCa4QxCbZC48z5f8/K5EDYxCbZAMuq6rA/Q5jD+Z0MKQBAHfYXgU2u+1iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CM.png
// module id = 1112
// module chunks = 0